
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/[...slugs]",
      function () {
        return require("private-next-pages/[brand]/[...slugs].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/[...slugs]"])
      });
    }
  